function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconCreditCard = function IconCreditCard(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M20.4404 4H3.6432C2.73031 4 2 4.8216 2 5.73449V17.9672C2 18.8801 2.73031 19.6104 3.6432 19.6104H20.3491C21.262 19.6104 21.9923 18.8801 21.9923 17.9672V5.73449C22.0836 4.8216 21.3533 4 20.4404 4ZM3.91707 5.73449H20.2578C20.3491 5.73449 20.4404 5.82578 20.4404 5.91707V7.37769H3.6432V5.91707C3.6432 5.82578 3.73449 5.73449 3.91707 5.73449ZM20.1665 17.9672H3.91707C3.82578 17.9672 3.73449 17.8759 3.73449 17.7846V11.8508H20.4404V17.7846C20.4404 17.8759 20.3491 17.9672 20.1665 17.9672Z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconCreditCard));
//# sourceMappingURL=IconCreditCard.js.map